import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import i18n from './i18n'
import ElementUI from 'element-ui'
import CustImg from '@/components/custImage'
import Empty from '@/components/empty'
import outFocus from '@/directives/outFocus'
import Notification from '@/components/notify'
import '@/assets/css/reset.css'
import '@/assets/css/common.less'
import 'element-ui/lib/theme-chalk/index.css'

import config from '@/constant'
import wpk from './wpk/index.js'
Vue.prototype._config = config
console.log(process.env.NODE_ENV,'process.env.NODE_ENV')
if (process.env.NODE_ENV === 'production' && !location.href.includes('-test')) {

  wpk.initWpk({
    bid: '424a6q3l-x1to1l8z',
    moduleName: 'ekt-cc'
  })
}

// 设置事件中心
/**
 * updateUserInfo：请求完成当前用户数据
 * updateAppConfig：请求完成配置
 * toggleMenu：切换主菜单展开收起
 */
const EventBus = new Vue()
Vue.prototype._Bus = EventBus

Vue.config.productionTip = false

// 注册一个全局自定义指令 `v-focus`
Vue.directive('outside', outFocus)
Vue.component('CustImg', CustImg)
Vue.component('Empty', Empty)
Vue.prototype._notify = Notification;

Vue.use(ElementUI)
// 本地测试使用，上线时需要注释
// window.onmessage = (e) => {
//   console.log('===========', e, document.body.style);
//   const {method, payload} = e.data || {}
//   if(method === 'setFloatPageStyle') {
//     const { width, height } = payload || {}
//     document.body.style.width = width + 'px'
//     document.body.style.height = height + 'px'
//   }
// }
window.vueInstance = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js